import { Config } from "./configTypes";
import { buildMalaysiaConfig } from "./malaysiaConfig";
import { buildInternationalConfig } from "./internationalConfig";
import { buildInvestConfig } from "./investConfig";

const configMap: { [key: string]: () => Promise<Config> | Config } = {
  malaysia: buildMalaysiaConfig,
  international: buildInternationalConfig,
  triveinvest: buildInvestConfig,
};

const getConfig = async (): Promise<Config> => {
  const url = window.location.href.toLowerCase();

  for (const key in configMap) {
    if (url.includes(key)) {
      return await configMap[key]();
    }
  }

  // default
  return await buildInternationalConfig();
};

export default getConfig;
